// extracted by mini-css-extract-plugin
export var active = "_a4-d";
export var blink = "_a4-e";
export var container = "_a4-5";
export var controls = "_a4-0";
export var controlsRight = "_a4-1";
export var fakeCursor = "_a4-c";
export var hidden = "_a4-b";
export var quillContainerSmall = "_a4-7";
export var quillEditor = "_a4-6";
export var quillEditorSmall = "_a4-8";
export var quillFormatButtons = "_a4-a";
export var quillToolbar = "_a4-9";
export var removePadding = "_a4-2";
export var state = "_a4-3";
export var stateTitle = "_a4-4";